export default __webpack_public_path__ + "66b82889b31e40377bcb1f71cdf7552d.png";